__turbopack_context__.v({
  "arrow": "VP2CWq_arrow",
  "content": "VP2CWq_content",
});
